import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import DashboardCompoment from '../components/common/DashboardCompoment';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import { usePrerequisites } from '../contexts/Prerequisites';

const ModalityDashboard = ({ params, data, ...rest }) => {
	const [breadcrumbs, setBreadcrumbs] = useBreadcrumbs();
	const [searchParams] = useSearchParams();
	const equipmentTypeId = searchParams.get('EquipmentTypeId');
	const [{ strings }] = usePrerequisites();

	useEffect(() => {
		setBreadcrumbs({
			breadcrumbs: [
				{ text: `${strings.ModalityDashboard}` },
			], subbreadcrumbs: [
				{ text: `${strings.Dashboard}`, to: '/dashboard' },
				{ text: `${strings.ModalityDashboard}` },
			]
		});
	}, [setBreadcrumbs])

	const parentFilters = useMemo(() => {
		let filters = [
			{ "operator": "$eq", "value": equipmentTypeId, "property": "equipmentTypeId", "type": "numeric" },
			{ "operator": "$eq", "value": false, "property": "InActive", "type": "boolean" }
		];

		return { filter: filters };

	}, [equipmentTypeId]);

	return <DashboardCompoment {...rest} fromModality={true} equipmentTypeId={equipmentTypeId} parentFilters={parentFilters} fromDashboard={false} />
};

export default ModalityDashboard;
